module.exports = __webpack_public_path__ + "img/ii.ff522994.png";